import React from 'react';
import { SalesDashboard } from './components/SalesDashboard';
import { ThemeProvider } from './contexts/ThemeContext';
export function App() {
  return <ThemeProvider data-id="element-0">
      <SalesDashboard data-id="element-1" />
    </ThemeProvider>;
}